var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChainBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    fill: "#4579E7",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.021 6.12a5.881 5.881 0 00-5.844 5.222h8.236v1.316H6.177A5.881 5.881 0 1012.02 6.12zM19.85 12a7.85 7.85 0 11-15.7 0 7.85 7.85 0 0115.7 0z",
    fill: "#4579E7"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IndoaXRlIi8+CjxlbGxpcHNlIG9wYWNpdHk9IjAuMSIgY3g9IjEyIiBjeT0iMTIuMDAwMSIgcng9IjEyIiByeT0iMTIuMDAwMSIgZmlsbD0iIzQ1NzlFNyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjAyMTEgNi4xMTk5MUM4Ljk5NTggNi4xMTk5MSA2LjUwNDA3IDguNDA0NDQgNi4xNzY5NiAxMS4zNDI1SDE0LjQxMzJWMTIuNjU4Mkg2LjE3NjkzQzYuNTAzOTUgMTUuNTk2NCA4Ljk5NTczIDE3Ljg4MSAxMi4wMjExIDE3Ljg4MUMxNS4yNjg5IDE3Ljg4MSAxNy45MDE3IDE1LjI0ODIgMTcuOTAxNyAxMi4wMDA1QzE3LjkwMTcgOC43NTI3MiAxNS4yNjg5IDYuMTE5OTEgMTIuMDIxMSA2LjExOTkxWk0xOS44NSAxMi4wMDAxQzE5Ljg1IDE2LjMzNTUgMTYuMzM1NSAxOS44NTAxIDEyIDE5Ljg1MDFDNy42NjQ1OSAxOS44NTAxIDQuMTUwMDIgMTYuMzM1NSA0LjE1MDAyIDEyLjAwMDFDNC4xNTAwMiA3LjY2NDYxIDcuNjY0NTkgNC4xNTAwMiAxMiA0LjE1MDAyQzE2LjMzNTUgNC4xNTAwMiAxOS44NSA3LjY2NDYxIDE5Ljg1IDEyLjAwMDFaIiBmaWxsPSIjNDU3OUU3Ii8+Cjwvc3ZnPgo=";
export { SvgChainBase as ReactComponent };